import { render, staticRenderFns } from "./PasswordButton.vue?vue&type=template&id=37b9bb84"
import script from "./PasswordButton.vue?vue&type=script&lang=js"
export * from "./PasswordButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports